import { render, staticRenderFns } from "./EditAccountDetails.vue?vue&type=template&id=1e95ddf1&scoped=true"
import script from "./EditAccountDetails.vue?vue&type=script&lang=js"
export * from "./EditAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./EditAccountDetails.vue?vue&type=style&index=0&id=1e95ddf1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e95ddf1",
  null
  
)

export default component.exports